import React from 'react';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

const postOrganisation = ComposedComponent => {
  const PostOrganisation = props => <ComposedComponent {...props} />;

  return reduxFetch([
    {
      resource: 'newOrganisation',
      method: 'post',
      request: values => ({
        url: apiRoutes.postOrganisation(),
        body: values,
        meta: {
          redirectRoute: '/organisations',
          toaster: {
            onSuccessMessage: 'Organisation created',
            onErrorMessage: 'Could not create organisation',
          },
        },
      }),
    },
  ])(PostOrganisation);
};

export default postOrganisation;
